// src/App.js

import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import { RequireAuth } from './Auth'

import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Customers from './pages/Customers'
import StaffManagement from './pages/StaffManagement'
import Attendance from './pages/Attendance'
import SalesManagement from './pages/SalesManagement'
import CreditCustomerPage from './pages/CreditCustomerPage'
import LoanManagement from './pages/LoanManagement'
import SalaryManagement from './pages/SalaryManagement'
import DailySummaryManagement from './pages/DailySummaryManagement'
import DateRangeReport from './pages/DateRangeReport'
import BillingBook from './pages/BillingBook'
import SalaryBonusManagement from './pages/SalaryBonusManagement'
import SalarySmsSheet from './pages/SalarySmsSheet'
import PurchaseManagement from './pages/PurchaseManagement'
import PurchaseStockManagement from './pages/PurchaseStockManagement'
import ResignationSettlement from './pages/ResignationSettlement'

export default function App() {
  return (
    <Routes>
      {/* Public route: OTP SMS sheet, no layout */}
      <Route
        path="/salary_sms_sheet"
        element={<SalarySmsSheet />}
      />

      {/* Public login */}
      <Route
        path="/login"
        element={<Login />}
      />

      {/* All other routes require login & layout */}
      <Route
        path="/*"
        element={
          <RequireAuth>
            <Layout>
              <Routes>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="customers" element={<Customers />} />
                <Route path="staff" element={<StaffManagement />} />
                <Route path="att" element={<Attendance />} />
                <Route path="sales" element={<SalesManagement />} />
                <Route path="sales/customer/:customerId" element={<CreditCustomerPage />} />
                <Route path="loan" element={<LoanManagement />} />
                <Route path="sal" element={<SalaryManagement />} />
                <Route path="sum" element={<DailySummaryManagement />} />
                <Route path="date" element={<DateRangeReport />} />
                <Route path="bill" element={<BillingBook />} />
                <Route path="bonus" element={<SalaryBonusManagement />} />
                <Route path="purchese" element={<PurchaseManagement />} />
                <Route path="/purchase-stock" element={<PurchaseStockManagement />} />
                <Route path="/resi" element={<ResignationSettlement />} />
              </Routes>
            </Layout>
          </RequireAuth>
        }
      />
    </Routes>
  )
}
